import * as React from "react";
import styled, { css } from "styled-components";
import { HelpBlock } from "components/bootstrap";
const ErrorMessage = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
  `
);
const HelpMessage = styled.span(
  ({ theme, $hasError }) => css`
    color: ${$hasError ? theme.colors.gray[50] : "inherit"};
  `
);
const InputDescription = ({ className = void 0, error = void 0, help = void 0 }) => {
  if (!help && !error) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(HelpBlock, { className: `${className != null ? className : ""} input-description` }, error && /* @__PURE__ */ React.createElement(ErrorMessage, null, error), !!error && !!help && /* @__PURE__ */ React.createElement("br", null), help && /* @__PURE__ */ React.createElement(HelpMessage, { $hasError: !!error }, help));
};
export default InputDescription;
